module.exports = __webpack_public_path__ + "static/media/icon_arrow-back.0cd5c7c6.svg";